<nav class="list-group list-group-flush bg-secondary min-h-vh">

  <a
    *appIfHasAllPermissions="[PERMISSION.PATIENT_READ_ALL]"
    [routerLinkActive]="['active']"
    [routerLink]="'/statistics'"
    class="list-group-item list-group-item-sidebar-secondary">
    <i class="fa-solid fa-chart-column"></i>
    {{ 'components.sidebar.statistics' | translate }}
  </a>

  <a
    *appIfHasAllPermissions="[PERMISSION.PATIENT_READ_ALL]"
    [routerLinkActive]="['active']"
    [routerLink]="'/patients'"
    class="list-group-item list-group-item-sidebar-secondary">
    <i class="fa-solid fa-users"></i>
    {{ 'components.sidebar.patients' | translate }}
  </a>

  <a
    *appIfHasAllPermissions="[PERMISSION.INQUIRY_INQUIRY_READ_ALL]"
    [routerLinkActive]="['active']"
    [routerLink]="'/inquiries'"
    class="list-group-item list-group-item-sidebar-secondary">
    <i class="fa-regular fa-envelope"></i>
    {{ 'components.sidebar.inquiries' | translate }}
  </a>

  <a
    *appIfHasAnyPermissions="[
    PERMISSION.ADMINISTRATION_EMAIL_READ_ALL,
    PERMISSION.ADMINISTRATION_PUBLICATION_READ_ALL,
    PERMISSION.ADMINISTRATION_TEAMMEMBER_READ_ALL
    ]"
    class="list-group-item list-group-item-sidebar"
    (click)="toggle(content.ADMINISTRATIONS)"
    [attr.aria-expanded]="!collapsed(content.ADMINISTRATIONS)">
    <i class="fa-solid fa-gears"></i>
    {{ 'components.sidebar.administration' | translate }}
    <i class="fa-solid position-absolute end-0 me-3 mt-1"
       [class.fa-chevron-up]="!collapsed(content.ADMINISTRATIONS)"
       [class.fa-chevron-down]="collapsed(content.ADMINISTRATIONS)"></i>
  </a>

  <ng-container *ngIf="!collapsed(content.ADMINISTRATIONS)">

    <a
      *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_EMAIL_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/emails'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-envelope"></i>
      {{ 'components.sidebar.emails' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_PUBLICATION_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/publications'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-newspaper"></i>
      {{ 'components.sidebar.publications' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_TEAMMEMBER_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/team-members'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-users"></i>
      {{ 'components.sidebar.team-members' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.PATIENTAUTHENTICATIONAUDIT_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/patients-login'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-user-shield"></i>
      {{ 'components.sidebar.patients-login' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_DIAGNOSIS_UPDATE_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/diagnoses'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-stethoscope"></i>
      {{ 'components.sidebar.diagnoses' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.USER_UPDATE_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/administration/users'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-user-gear"></i>
      {{ 'components.sidebar.users' | translate }}
    </a>

  </ng-container>

  <a
    *appIfHasAnyPermissions="[PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL]"
    class="list-group-item list-group-item-sidebar"
    (click)="toggle(content.QUALITY_MANAGEMENT)"
    [attr.aria-expanded]="!collapsed(content.QUALITY_MANAGEMENT)">
    <i class="fa-solid fa-gears"></i>
    {{ 'components.sidebar.quality-management' | translate }}
    <i class="fa-solid position-absolute end-0 me-3 mt-1"
       [class.fa-chevron-up]="!collapsed(content.QUALITY_MANAGEMENT)"
       [class.fa-chevron-down]="collapsed(content.QUALITY_MANAGEMENT)"></i>
  </a>

  <ng-container *ngIf="!collapsed(content.QUALITY_MANAGEMENT)">
    <a
      *appIfHasAllPermissions="[PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/quality-management/processes'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-gears"></i>
      {{ 'components.sidebar.processes' | translate }}
    </a>

    <a
      *appIfHasAllPermissions="[PERMISSION.QUALITYMANAGEMENT_PROCESS_READ_ALL, PERMISSION.PRIVATEATTACHMENT_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/quality-management/documents'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-folder-open"></i>
      {{ 'components.sidebar.documents' | translate }}
    </a>
  </ng-container>

  <a
    *appIfHasAnyPermissions="[
      PERMISSION.TIMETRACKING_TIMETRACKINGEMPLOYEE_TIMETRACKINGEMPLOYEE_READ_ALL,
      PERMISSION.TIMETRACKING_TIMETRACKINGENTRY_READ_ALL,
    ]"
    class="list-group-item list-group-item-sidebar"
    (click)="toggle(content.TIME_TRACKING)"
    [attr.aria-expanded]="!collapsed(content.TIME_TRACKING)">
    <i class="fa-regular fa-clock"></i>
    {{ 'components.sidebar.time-tracking' | translate }}
    <i class="fa-solid position-absolute end-0 me-3 mt-1"
       [class.fa-chevron-up]="!collapsed(content.TIME_TRACKING)"
       [class.fa-chevron-down]="collapsed(content.TIME_TRACKING)"></i>
  </a>

  <ng-container *ngIf="!collapsed(content.TIME_TRACKING)">
    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_EMPLOYEE]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/entries'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-clock"></i>
      {{ 'components.sidebar.entries' | translate }}
    </a>

    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_EMPLOYEE]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/absence-requests/personal'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-calendar"></i>
      {{ 'components.sidebar.personal' | translate }}
    </a>

    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/absence-requests/absences'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-umbrella-beach"></i>
      {{ 'components.sidebar.absences' | translate }}
    </a>

    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/absence-requests/requests'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-calendar-plus"></i>
      {{ 'components.sidebar.requests' | translate }}
    </a>

    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_HUMAN_RESOURCES, RoleEnum.TIME_TRACKING_TEAM_LEAD]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/overview'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-list-ul"></i>
      {{ 'components.sidebar.overview' | translate }}
    </a>

    <a
      *appIfHasAnyRoles="[RoleEnum.TIME_TRACKING_HUMAN_RESOURCES]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/employees'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-solid fa-users"></i>
      {{ 'components.sidebar.employees' | translate }}
    </a>

    <a
      *appIfHasAnyPermissions="[PERMISSION.TIMETRACKING_PUBLICHOLIDAY_READ_ALL]"
      [routerLinkActive]="['active']"
      [routerLink]="'/time-tracking/public-holidays'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-star"></i>
      {{ 'components.sidebar.public_holidays' | translate }}
    </a>
  </ng-container>

  <a
    (click)="logout()"
    class="list-group-item list-group-item-sidebar">
    <i class="fa fa-external-link"></i> {{ 'components.sidebar.logout' | translate }}
  </a>

</nav>
